import { useCallback } from "react";
import { match } from "ts-pattern";
import { ChevronUpIcon } from "@heroicons/react/24/solid";
import CommentResponseResource from "common/resources/Project/Config/Forum/Comment/CommentResponseResource";
import Typography from "components/elements/Typography";
import I18n from "components/materials/I18n";
import classNames from "classnames";
import classes from "./classes.module.scss";

type IProps = {
	comment: Pick<CommentResponseResource, "id">;
	onToggleCollapse: () => void;
	areRepliesCollapsed: boolean;
	maxDepthReached: boolean;
	repliesCount: number;
};

export default function CommentResponseButton(props: IProps) {
	const getResponseText = useCallback(() => {
		return I18n.trslt(
			match(props.repliesCount)
				.when(
					(n) => props.maxDepthReached && n > 0,
					() => I18n.asset.pages.post.comment.reply.see_more,
				)
				.with(0, () => I18n.asset.pages.post.comment.reply.no_reply)
				.with(1, () => I18n.asset.pages.post.comment.reply.single_reply)
				.otherwise(() => I18n.asset.pages.post.comment.reply.many_replies),
			{ n: props.repliesCount?.toFixed() },
		);
	}, [props]);

	const onClick = useCallback(() => {
		if (props.repliesCount === 0 && !props.maxDepthReached) return;
		props.onToggleCollapse();
	}, [props]);

	return (
		<div className={classes["root"]} onClick={onClick}>
			<ChevronUpIcon
				className={classNames(classes["icon"], {
					[classes["collapsed"]!]: props.areRepliesCollapsed,
				})}
			/>
			<Typography>{getResponseText()}</Typography>
		</div>
	);
}
